import React, {memo, useState} from "react"
import s from "./myInput.module.scss"
import {IoCloseSharp, IoEyeOffOutline, IoEyeOutline} from "react-icons/io5"

interface Props extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    value: string | number
    label: string | any
    name?: string
    type?: string
    isPassword?: boolean
    clear?: () => void
    isInvalid?: string | boolean
    disabled?: boolean
    wrapperStyle?: React.CSSProperties
    containerStyle?: React.CSSProperties
}

export const MyInput: React.FC<Props> = memo(({value, label, type, clear, isInvalid, isPassword, disabled, wrapperStyle, containerStyle, ...props}) => {
    const [showPass, setShowPass] = useState(false)

    return (
        <div className={s.wrapper} style={wrapperStyle}>
            <div className={`${s.container} ${isInvalid && s.inputError} ${disabled && s.disableContainer}`} style={containerStyle}>
                <input value={value}
                       placeholder={label}
                       type={isPassword ? showPass ? 'text' : 'password' : type || 'text'}
                       className={`${s.input} ${isPassword && showPass ? 'showPassword' : 'hidePassword'}`}
                       disabled={disabled}
                       {...props}
                />
                {
                    !disabled ? <div className={s.iconsView}>
                            {isPassword && <div className={s.icon} style={clear && {marginRight: 0}} onClick={() => setShowPass(!showPass)}>
                                {showPass ? <IoEyeOffOutline size={18}/> : <IoEyeOutline size={18}/>}
                            </div>}
                            {clear && <div className={s.icon} onClick={() => clear()}>
                                <IoCloseSharp size={18}/>
                            </div>}
                        </div>
                        : null
                }
                <label className={s.label}>{label}</label>
            </div>
            {isInvalid && <div className={s.errorText}>{isInvalid}</div>}
        </div>
    )
})
